import { render, staticRenderFns } from "./lastLocation.vue?vue&type=template&id=686ee13b&scoped=true&"
import script from "./lastLocation.vue?vue&type=script&lang=ts&"
export * from "./lastLocation.vue?vue&type=script&lang=ts&"
import style0 from "./lastLocation.vue?vue&type=style&index=0&id=686ee13b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ee13b",
  null
  
)

export default component.exports